import {createFileRoute} from '@tanstack/react-router'

import {RentalAssetDetailsPage} from '../../../assets/rental-assets/rental-asset-details-page'

export const Route = createFileRoute('/_app/rental-assets/$assetId')({
    component: RentalAssetDetailsRoute,
})

function RentalAssetDetailsRoute() {
    const {assetId} = Route.useParams()

    return <RentalAssetDetailsPage assetId={assetId} />
}
